<template>
  <div class="header-banner bg-theme-grad">
    <div class="nk-banner">
      <div class="banner banner-page">
        <div class="banner-wrap">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-xl-6 col-lg-9">
                <div class="banner-caption cpn tc-light text-center">
                  <div class="cpn-head">
                    <slot name="banner-title"></slot>         
                    <p>NIPOST ESTAMP is an electronic stamp that can be used for Postal purposes, Philately and also for denotion of Documents.</p> 
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nk-ovm shape-a-sm"></div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>
